import React from 'react'

export default function SimpleSpinner() {
  return (
    <div id='simple-spinner'>
      <span></span>
    </div>
  )
}
